module.exports = __webpack_public_path__ + "static/media/Logo.dbad5b15.png";